import * as R from "ramda";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { showNotification, withDataProvider } from "react-admin";
import Button from "@material-ui/core/Button";

import { dataProvider } from "../../App";
import { SEND_PUSH } from "../../misc/constants";

class SendPushButton extends Component {
  handleClick = () => {
    const { record } = this.props;
    dataProvider(SEND_PUSH, undefined, { id: record.id })
      .then(() => {
        this.props.dispatch(showNotification("Push has been sent"));
      })
      .catch((err) => {
        const message = R.pathOr(null, ["body", "message"], err);
        if (message) {
          this.props.dispatch(showNotification(message, "warning"));
          return;
        } else {
          this.props.dispatch(
            showNotification("Error: Push won`t sent", "warning")
          );
        }
      });
  };

  render() {
    return (
      <Button disabled={this.props.disabled} onClick={this.handleClick}>
        Send Push
      </Button>
    );
  }
}

SendPushButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  showNotification: PropTypes.func.isRequired,
  record: PropTypes.object,
};

export default withDataProvider(SendPushButton);
